export default __webpack_public_path__ + "static/media/duine.82e7ef75.mp3";